var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "5",
      "width": "20"
    }
  }, [_vm._v("必要能力")]), _vm._v(" "), _c('td', {
    staticClass: "fb",
    attrs: {
      "width": "60"
    }
  }, [_vm._v("积极主动")]), _vm._v(" "), _c('td', [_vm._v("面试表现积极，有主动分析问题解决问题的能力，并且能够在过程中改进方案，有备用方案保障计划的正常执行")]), _vm._v(" "), _c('td', [_vm._v("有较高的主动性，能够主动针对当前的主要矛盾提出自己的方案")]), _vm._v(" "), _c('td', [_vm._v("有一定自主能力，可以对指派的任务提出自己的想法")]), _vm._v(" "), _c('td', [_vm._v("几乎很少主动从事某件事情，需要指派任务")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb"
  }, [_vm._v("沟通表达")]), _vm._v(" "), _c('td', [_vm._v("回答问题积极主动，能很好理解别人，描述清晰语言准确，言谈自信语言流畅")]), _vm._v(" "), _c('td', [_vm._v("能理解他人，会主动表达自己观点，回答积极，且回答切题")]), _vm._v(" "), _c('td', [_vm._v("交流顺畅，表达清晰，正常问答")]), _vm._v(" "), _c('td', [_vm._v("理解能力不足，沟通意愿弱，有问才有答")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb"
  }, [_vm._v("学习能力")]), _vm._v(" "), _c('td', [_vm._v("学习能力很强，对新事物表现出强烈的兴趣，有完成任务的自信，学习的方法、措施令人满意，遭遇问题不会轻易退缩")]), _vm._v(" "), _c('td', [_vm._v("学习能力较强，有对新事物的学习思路，可以自主学习，但是持续时间较久，对困难的处理偏弱")]), _vm._v(" "), _c('td', [_vm._v("学习能力一般，可以看到工作中的进步，但无法完成自主学习的目标，需要专人指导")]), _vm._v(" "), _c('td', [_vm._v("学习能力偏弱，过往经历无法看到明显的进步")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb"
  }, [_vm._v("技术能力")]), _vm._v(" "), _c('td', [_vm._v("有较好的开发经验，有较强代码能力，能开发工具，带过开发团队，能协调整体开发流程，回答问题的逻辑性极强，技术题目回答超出预期")]), _vm._v(" "), _c('td', [_vm._v("有较好的开发经验，有较好的代码能力，深入开发过相关系统，了解开发的整体流程，逻辑思维较强，发散思维面较广，技术题目能基本答上")]), _vm._v(" "), _c('td', [_vm._v("有一定的开发经验，有基本的计算机知识，只开发过基础系统，回答问题有有一定的条理，知道一些逻辑实现")]), _vm._v(" "), _c('td', [_vm._v("薄弱的开发经验，完全不了解计算机知识，思维广度有限，发散思维薄弱")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb"
  }, [_vm._v("工作态度")]), _vm._v(" "), _c('td', [_vm._v("加班耐性和稳定性极高，工作中责任心很强，负责的任务能保质保量的完成，此外还能主动针对产品的改进做出努力")]), _vm._v(" "), _c('td', [_vm._v("加班耐性和稳定性很高，责任心较强，可以保证委派任务的完成")]), _vm._v(" "), _c('td', [_vm._v("加班耐性和稳定性一般，责任心一般，仍有可能出现指派工作没有很好完成的情况")]), _vm._v(" "), _c('td', [_vm._v("加班耐性和稳定性差，对待工作没有责任感")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "7"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "fb",
    attrs: {
      "rowspan": "5"
    }
  }, [_vm._v("加分项")]), _vm._v(" "), _c('td', {
    staticClass: "fb"
  }, [_vm._v("游戏经验")]), _vm._v(" "), _c('td', [_vm._v("经验丰富，重度、高端玩家，熟悉各种系统，能说出对系统的理解")]), _vm._v(" "), _c('td', [_vm._v("喜欢玩游戏，涉猎广泛，游戏取向和我司游戏类型一致对游戏有自己的理解")]), _vm._v(" "), _c('td', [_vm._v("玩游戏比较丰富，但不够深入；或游戏玩的不多但很深入")]), _vm._v(" "), _c('td', [_vm._v("玩过较少游戏，对游戏有兴趣")]), _vm._v(" "), _c('td')])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-483c331c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/score-tips/score-tips-develop.vue
// module id = null
// module chunks = 